export const panels: any[] = [
  { name: 'Tranche Analysis', label: 'tranches', x: 0, y: 0, cols: 9, rows: 6, selected: true, component: 'Tranches' },
  { name: 'Equity Ticker', label: 'equity', x: 9, y: 0, cols: 3, rows: 6, selected: true, component: 'Equity' },
  { name: 'Secondaries', label: 'secondaries', x: 0, y: 6, cols: 12, rows: 6, selected: true, component: 'Secondaries' },
  { name: 'Peer Analysis', label: 'peerAnalysis', x: 0, y: 0, cols: 12, rows: 6, selected: false, component: 'PeerAnalysis' },
  { name: 'Swap Curves', label: 'swaps', x: 0, y: 0, cols: 5, rows: 6, selected: false, component: 'Swaps' },
  { name: 'Treasury Security', label: 'treasury', x: 0, y: 0, cols: 7, rows: 6, selected: false, component: 'Treasury' },
];

